import { forwardRef } from 'react';

import { SvgStyled } from '@sternum/web/icons/icons.styles';
import { IconProps } from '@sternum/web/icons/icons.types';

export const TextWidgetIcon = forwardRef<SVGSVGElement, IconProps>(function TextWidgetIcon(
  { height = 32, width = 32, hasCursorPointer = false, ...props },
  ref,
) {
  return (
    <SvgStyled
      ref={ref}
      width={width}
      height={height}
      viewBox="0 0 32 32"
      data-has-cursor-pointer={hasCursorPointer}
      {...props}
    >
      <path
        d="M1 8.23529H31V26.5882C31 27.3679 30.3895 28 29.6364 28H2.36364C1.61052 28 1 27.3679 1 26.5882V8.23529Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M31 8.23529H29.6364V26.5882H2.36364V8.23529H1V26.5882C1 27.3679 1.61052 28 2.36364 28H29.6364C30.3895 28 31 27.3679 31 26.5882V8.23529Z"
        fill="#5137A1"
      />
      <path
        d="M1 5.41176C1 4.63207 1.61052 4 2.36364 4H29.6364C30.3895 4 31 4.63207 31 5.41176V8.23529H1V5.41176Z"
        fill="#5137A1"
      />
      <path
        d="M3.72727 6.11765C3.72727 6.5075 3.42201 6.82353 3.04545 6.82353C2.6689 6.82353 2.36364 6.5075 2.36364 6.11765C2.36364 5.7278 2.6689 5.41176 3.04545 5.41176C3.42201 5.41176 3.72727 5.7278 3.72727 6.11765Z"
        fill="#E8E1FC"
      />
      <path
        d="M6.45455 6.11765C6.45455 6.5075 6.14928 6.82353 5.77273 6.82353C5.39617 6.82353 5.09091 6.5075 5.09091 6.11765C5.09091 5.7278 5.39617 5.41176 5.77273 5.41176C6.14928 5.41176 6.45455 5.7278 6.45455 6.11765Z"
        fill="#CFC5F0"
      />
      <path
        d="M9.18182 6.11765C9.18182 6.5075 8.87656 6.82353 8.5 6.82353C8.12344 6.82353 7.81818 6.5075 7.81818 6.11765C7.81818 5.7278 8.12344 5.41176 8.5 5.41176C8.87656 5.41176 9.18182 5.7278 9.18182 6.11765Z"
        fill="#E8E1FC"
      />
      <path
        d="M14.8561 21.6498L14.2568 19.9954H10.5748L9.96218 21.6498H7.81818L11.6135 11.7647H13.2448L17.0534 21.6498H14.8561ZM11.2406 18.2031H13.591L12.4324 15.046L11.2406 18.2031Z"
        fill="#EF145D"
      />
      <path
        d="M22.7729 14.7151H24.6972V21.6498H22.7729V20.6641C22.2846 21.4131 21.5744 21.7877 20.6422 21.7877C20.074 21.7877 19.5502 21.6268 19.0708 21.3051C18.5959 20.9789 18.2208 20.54 17.9456 19.9885C17.6704 19.4324 17.5328 18.8281 17.5328 18.1756C17.5328 17.523 17.6704 16.921 17.9456 16.3695C18.2208 15.8134 18.5959 15.3768 19.0708 15.0597C19.5502 14.7381 20.074 14.5772 20.6422 14.5772C21.5744 14.5772 22.2846 14.954 22.7729 15.7077V14.7151ZM21.095 19.8851C21.5655 19.8851 21.9628 19.722 22.2868 19.3957C22.6109 19.0648 22.7729 18.6581 22.7729 18.1756C22.7729 17.6976 22.6109 17.2932 22.2868 16.9623C21.9628 16.6314 21.5655 16.466 21.095 16.466C20.6333 16.466 20.2383 16.6337 19.9098 16.9692C19.5813 17.3001 19.4171 17.7022 19.4171 18.1756C19.4171 18.6535 19.5791 19.0579 19.9031 19.3888C20.2316 19.7197 20.6289 19.8851 21.095 19.8851Z"
        fill="#EF145D"
      />
    </SvgStyled>
  );
});
